<template>
  <section class="city-map-legend__block">
    <div class="city-map-legend__title" :class="[mapLayout,mainTextStyle]">
      <span v-html="titleDecoded"></span>
    </div>
    <div class="city-map-legend__subtitle" :class="[secondaryTextStyle]" v-html="subTitleDecoded"></div>
  </section>
</template>

<script>
import ImageTemplateModule from "../store-mixin";

export default {
  name: 'ImageTemplateTitle',
  mixins: [ImageTemplateModule()],
  watch: {
    mainText: {
      handler: function (newValue, oldValue) {
        this.titleDecoded = this.$twemoji.parse(newValue)
      },
      immediate: true
    },
    secondaryText: {
      handler: function (newValue, oldValue) {
        this.subTitleDecoded = this.$twemoji.parse(newValue)
      },
      immediate: true
    },
  },
  data() {
    return {
      titleDecoded: null,
      subTitleDecoded: null,
    }
  },
  computed: {
    coordsLabel() {
      let [lat, lng] = this.center
      return `${Number(lat).toFixed(3)}° N / ${Number(lng).toFixed(3)}° E`
    },
  }
}
</script>

<style scoped lang="scss">
@import url('https://fonts.googleapis.com/css?family=Montserrat:300,500,700&display=swap');

.city-map-legend__title{
  color: #292929;
  font-size: 50px;
  letter-spacing: 1px;
  &.font-4 {
    font-size: 50px;
  }
}
.city-map-legend__subtitle{
  color: #292929;
  font-size: 32px;
  margin-top: 7px;
  margin-bottom: 28px;
  line-height: 36px;
  letter-spacing: 1.5px;
}

.font-1 {
  font-family: 'Futura PT';
  font-weight: bold;
  font-style: normal;
}

.font-2 {
  font-family: 'Amatic SC';
  font-weight: bold;
  font-style: normal;
}

.font-3 {
  font-family: 'Futura XBlk BT';
  font-weight: 900;
  font-style: normal;
}

.font-4 {
  font-family: 'Blacksword';
  font-weight: normal;
  font-style: normal;
}

.font-5 {
  font-family: 'Cardo';
  font-weight: normal;
  font-style: normal;
}

.font-6 {
  font-family: 'Futura PT';
  font-weight: normal;
  font-style: normal;
  //font-weight: bold;
}

.city-map-legend {


  &__block {
    background: white;
    //background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.6) 15%, rgba(255, 255, 255, 1) 35%, rgba(255, 255, 255, 1) 100%);
    text-align: center;
    padding-top: 50px;
    position: absolute;
    bottom: -5px;
    left: -2px;
    right: -2px;
    /*position: relative;*/
    z-index: 999;
    /*box-shadow: 0 -2px 6px 0px #DDDDDD;*/
    ::v-deep .emoji {
      height: 40px !important;
      width: 40px !important;
      vertical-align: middle !important;
    }
  }

  &__title {
    //text-transform: uppercase;
    //font-weight: bold;
    //font-family: 'Montserrat', sans-serif;
    //letter-spacing: 16px;
    //margin-bottom: -5px;

    &.vertical {

    }

    &.horizontal {

    }


    &--img {
      height: 40px;
      width: 40px;
      vertical-align: middle !important;
    }
  }

  &__subtitle {
    .city-name {
      //text-transform: uppercase;
    }
  }
}

</style>

